import "./Icon.js";
import { IconAccountBalanceWallet } from "./variants/IconAccountBalanceWallet.js";
import { IconAdd } from "./variants/IconAdd.js";
import { IconAdminMeds } from "./variants/IconAdminMeds.js";
import { IconApprovalDelegation } from "./variants/IconApprovalDelegation.js";
import { IconArchive } from "./variants/IconArchive.js";
import { IconArrowDownward } from "./variants/IconArrowDownward.js";
import { IconAssignment } from "./variants/IconAssignment.js";
import { IconBadge } from "./variants/IconBadge.js";
import { IconBolt } from "./variants/IconBolt.js";
import { IconBox } from "./variants/IconBox.js";
import { IconCached } from "./variants/IconCached.js";
import { IconCalendarToday } from "./variants/IconCalendarToday.js";
import { IconCall } from "./variants/IconCall.js";
import { IconCancel } from "./variants/IconCancel.js";
import { IconCheck } from "./variants/IconCheck.js";
import { IconCheckCircle } from "./variants/IconCheckCircle.js";
import { IconChevronLeft } from "./variants/IconChevronLeft.js";
import { IconChevronRight } from "./variants/IconChevronRight.js";
import { IconClose } from "./variants/IconClose.js";
import { IconCloudUpload } from "./variants/IconCloudUpload.js";
import { IconControlledSubstance } from "./variants/IconControlledSubstance.js";
import { IconDelete } from "./variants/IconDelete.js";
import { IconDeliverBox } from "./variants/IconDeliverBox.js";
import { IconDescription } from "./variants/IconDescription.js";
import { IconDownload } from "./variants/IconDownload.js";
import { IconEdit } from "./variants/IconEdit.js";
import { IconError } from "./variants/IconError.js";
import { IconEvent } from "./variants/IconEvent.js";
import { IconEventBusy } from "./variants/IconEventBusy.js";
import { IconFavorite } from "./variants/IconFavorite.js";
import { IconFileOpen } from "./variants/IconFileOpen.js";
import { IconFilter } from "./variants/IconFilter.js";
import { IconFilterList } from "./variants/IconFilterList.js";
import { IconFlag } from "./variants/IconFlag.js";
import { IconForwardToInbox } from "./variants/IconForwardToInbox.js";
import { IconFullscreen } from "./variants/IconFullscreen.js";
import { IconGenericHome } from "./variants/IconGenericHome.js";
import { IconGenericPharmacy } from "./variants/IconGenericPharmacy.js";
import { IconGroup } from "./variants/IconGroup.js";
import { IconHeadphones } from "./variants/IconHeadphones.js";
import { IconHealthAndSafety } from "./variants/IconHealthAndSafety.js";
import { IconHelp } from "./variants/IconHelp.js";
import { IconHelpCenter } from "./variants/IconHelpCenter.js";
import { IconHome } from "./variants/IconHome.js";
import { IconImage } from "./variants/IconImage.js";
import { IconInfo } from "./variants/IconInfo.js";
import { IconIosShare } from "./variants/IconIosShare.js";
import { IconKeep } from "./variants/IconKeep.js";
import { IconKeyboardArrowDown } from "./variants/IconKeyboardArrowDown.js";
import { IconLibraryBooks } from "./variants/IconLibraryBooks.js";
import { IconLink } from "./variants/IconLink.js";
import { IconLocalPharmacy } from "./variants/IconLocalPharmacy.js";
import { IconLocalShipping } from "./variants/IconLocalShipping.js";
import { IconLocationOn } from "./variants/IconLocationOn.js";
import { IconLock } from "./variants/IconLock.js";
import { IconLogoDev } from "./variants/IconLogoDev.js";
import { IconLogout } from "./variants/IconLogout.js";
import { IconMailOrder } from "./variants/IconMailOrder.js";
import { IconMedication } from "./variants/IconMedication.js";
import { IconMenu } from "./variants/IconMenu.js";
import { IconMenuOpen } from "./variants/IconMenuOpen.js";
import { IconMoreHoriz } from "./variants/IconMoreHoriz.js";
import { IconMoreVert } from "./variants/IconMoreVert.js";
import { IconMyLocation } from "./variants/IconMyLocation.js";
import { IconNestClockFarsightAnalog } from "./variants/IconNestClockFarsightAnalog.js";
import { IconNoteAlt } from "./variants/IconNoteAlt.js";
import { IconNumbers } from "./variants/IconNumbers.js";
import { IconOpenInNew } from "./variants/IconOpenInNew.js";
import { IconPaid } from "./variants/IconPaid.js";
import { IconPayments } from "./variants/IconPayments.js";
import { IconPDF } from "./variants/IconPDF.js";
import { IconPermContactCalendar } from "./variants/IconPermContactCalendar.js";
import { IconPerson } from "./variants/IconPerson.js";
import { IconPill } from "./variants/IconPill.js";
import { IconPlaylistAddCheck } from "./variants/IconPlaylistAddCheck.js";
import { IconPrescription } from "./variants/IconPrescription.js";
import { IconPrivacyTip } from "./variants/IconPrivacyTip.js";
import { IconRefresh } from "./variants/IconRefresh.js";
import { IconReply } from "./variants/IconReply.js";
import { IconReport } from "./variants/IconReport.js";
import { IconRoute } from "./variants/IconRoute.js";
import { IconSavings } from "./variants/IconSavings.js";
import { IconSchedule } from "./variants/IconSchedule.js";
import { IconSearch } from "./variants/IconSearch.js";
import { IconSecurity } from "./variants/IconSecurity.js";
import { IconSend } from "./variants/IconSend.js";
import { IconSettings } from "./variants/IconSettings.js";
import { IconShoppingBag } from "./variants/IconShoppingBag.js";
import { IconSms } from "./variants/IconSms.js";
import { IconStethoscope } from "./variants/IconStethoscope.js";
import { IconSupportAgent } from "./variants/IconSupportAgent.js";
import { IconTranslate } from "./variants/IconTranslate.js";
import { IconTune } from "./variants/IconTune.js";
import { IconUnarchive } from "./variants/IconUnarchive.js";
import { IconUnfoldMore } from "./variants/IconUnfoldMore.js";
import { IconUpdate } from "./variants/IconUpdate.js";
import { IconUpload } from "./variants/IconUpload.js";
import { IconUserHeart } from "./variants/IconUserHeart.js";
import { IconVerifiedUser } from "./variants/IconVerifiedUser.js";
import { IconViewColumn } from "./variants/IconViewColumn.js";
import { IconVisibility } from "./variants/IconVisibility.js";
import { IconVisibilityOff } from "./variants/IconVisibilityOff.js";
import { IconWarning } from "./variants/IconWarning.js";
import "react";

//#region src/components/icon/get-icon-by-name.ts
const iconMap = {
	"account-balance-wallet": IconAccountBalanceWallet,
	add: IconAdd,
	"admin-meds": IconAdminMeds,
	"approval-delegation": IconApprovalDelegation,
	archive: IconArchive,
	"arrow-downward": IconArrowDownward,
	assignment: IconAssignment,
	badge: IconBadge,
	bolt: IconBolt,
	box: IconBox,
	cached: IconCached,
	"calendar-today": IconCalendarToday,
	call: IconCall,
	cancel: IconCancel,
	check: IconCheck,
	"check-circle": IconCheckCircle,
	"chevron-left": IconChevronLeft,
	"chevron-right": IconChevronRight,
	close: IconClose,
	"cloud-upload": IconCloudUpload,
	"controlled-substance": IconControlledSubstance,
	delete: IconDelete,
	"deliver-box": IconDeliverBox,
	description: IconDescription,
	download: IconDownload,
	edit: IconEdit,
	error: IconError,
	event: IconEvent,
	"event-busy": IconEventBusy,
	favorite: IconFavorite,
	"file-open": IconFileOpen,
	filter: IconFilter,
	"filter-list": IconFilterList,
	flag: IconFlag,
	"forward-to-inbox": IconForwardToInbox,
	fullscreen: IconFullscreen,
	"generic-home": IconGenericHome,
	"generic-pharmacy": IconGenericPharmacy,
	group: IconGroup,
	headphones: IconHeadphones,
	"health-and-safety": IconHealthAndSafety,
	help: IconHelp,
	"help-center": IconHelpCenter,
	home: IconHome,
	image: IconImage,
	info: IconInfo,
	"ios-share": IconIosShare,
	keep: IconKeep,
	"keyboard-arrow-down": IconKeyboardArrowDown,
	"library-books": IconLibraryBooks,
	link: IconLink,
	"local-pharmacy": IconLocalPharmacy,
	"local-shipping": IconLocalShipping,
	"location-on": IconLocationOn,
	lock: IconLock,
	"logo-dev": IconLogoDev,
	logout: IconLogout,
	"mail-order": IconMailOrder,
	medication: IconMedication,
	menu: IconMenu,
	"menu-open": IconMenuOpen,
	"more-horiz": IconMoreHoriz,
	"more-vert": IconMoreVert,
	"my-location": IconMyLocation,
	"nest-clock-farsight-analog": IconNestClockFarsightAnalog,
	"note-alt": IconNoteAlt,
	numbers: IconNumbers,
	"open-in-new": IconOpenInNew,
	paid: IconPaid,
	payments: IconPayments,
	pdf: IconPDF,
	"perm-contact-calendar": IconPermContactCalendar,
	person: IconPerson,
	pill: IconPill,
	"playlist-add-check": IconPlaylistAddCheck,
	prescription: IconPrescription,
	"privacy-tip": IconPrivacyTip,
	refresh: IconRefresh,
	reply: IconReply,
	report: IconReport,
	route: IconRoute,
	savings: IconSavings,
	schedule: IconSchedule,
	search: IconSearch,
	security: IconSecurity,
	send: IconSend,
	settings: IconSettings,
	"shopping-bag": IconShoppingBag,
	sms: IconSms,
	stethoscope: IconStethoscope,
	"support-agent": IconSupportAgent,
	translate: IconTranslate,
	tune: IconTune,
	unarchive: IconUnarchive,
	"unfold-more": IconUnfoldMore,
	update: IconUpdate,
	upload: IconUpload,
	"user-heart": IconUserHeart,
	"verified-user": IconVerifiedUser,
	"view-column": IconViewColumn,
	visibility: IconVisibility,
	"visibility-off": IconVisibilityOff,
	warning: IconWarning
};
const getIconByName = (name) => iconMap[name];

//#endregion
export { getIconByName };